<template>
  <div>
    <b-row>
      <!-- SMS Configuration -->
      <b-col md="6">
        <b-card>
          <h5 class="font-weight-bolder mb-2">SMS Configuration</h5>
          <b-form-group>
            <label class="font-weight-bold" for="SMS Provider"
              >SMS Provider</label
            >
            <b-form-select
              :options="providers"
              v-model="form.provider.value"
            ></b-form-select>
          </b-form-group>

          <b-form-group>
            <label class="font-weight-bold" for="Sender Name"
              >Sender Name</label
            >
            <b-form-input v-model="form.senderName"></b-form-input>
          </b-form-group>

          <b-form-group>
            <label class="font-weight-bold" for="API Key">API Key</label>
            <b-form-input type="password" v-model="form.apiKey"></b-form-input>
          </b-form-group>

          <b-form-group label="Webhook URL">
            <label class="font-weight-bold" for="Webhook URL"
              >Webhook URL</label
            >
            <b-form-input v-model="form.webhookUrl"></b-form-input>
          </b-form-group>

          <b-form-group>
            <label class="font-weight-bolder"> Enable SMS Notifications</label>
            <div class="d-flex align-items-center justify-content-between">
              <span>Allow SMS notifications to be sent</span>
              <b-form-checkbox v-model="form.enableNotifications" switch />
            </div>
          </b-form-group>

          <b-button variant="success" block>
            <feather-icon icon="SaveIcon" />
            Save SMS Settings
          </b-button>
        </b-card>
      </b-col>

      <!-- SMS Templates -->
      <b-col md="6">
        <b-card>
          <h5 class="font-weight-bolder mb-2">SMS Templates</h5>

          <div v-for="(template, index) in templates" :key="index" class="mb-2">
            <b-card border-variant="secondary" body-class="p-2">
              <div class="">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="font-weight-bolder mb-0">{{ template.title }}</p>
                    <span class="small text-muted">{{ template.content }}</span>
                  </div>
                  <b-badge pill variant="success">Active</b-badge>
                </div>
              </div>
              <div class="mt-1">
                <b-button
                  size="sm"
                  variant="outline-dark text-body"
                  class="mr-1"
                  >Edit</b-button
                >
                <b-button size="sm" variant="outline-dark text-body"
                  >Test</b-button
                >
              </div>
            </b-card>
          </div>

          <b-button variant="outline-dark text-body" block>
            + Add SMS Template
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormCheckbox,
  BButton,
  BBadge,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormCheckbox,
    BButton,
    BBadge,
  },
  data() {
    const providers = [
      {
        value: "Twilio",
        text: "Twilio",
      },
      {
        value: "AWS SNS",
        text: "AWS SNS",
      },

      { value: "MessageBird", text: "MessageBird" },
      {
        value: "Clicksend",
        text: "Clicksend",
      },
    ];
    return {
      form: {
        provider: providers[0],
        senderName: "UPC Betting",
        apiKey: "",
        webhookUrl: "https://api.upc.com.au/sms/webhook",
        enableNotifications: false,
      },
      providers,
      templates: [
        {
          title: "Welcome SMS",
          content:
            "Welcome to UPC! Your account is ready. Start betting now: [login_link]",
        },
        {
          title: "Deposit Confirmation",
          content:
            "Deposit successful! $[amount] added to your account. Current balance: $[balance]",
        },
        {
          title: "Security Alert",
          content:
            "Login from new device detected. If this wasn’t you, contact support.",
        },
      ],
    };
  },
  methods: {},
};
</script>
